import React from "react";

import clsx from "clsx";

import { Column } from "@/components/containers";

import { PointDetailRow } from "./PointDetailRow";

export interface ChargePointDetailsProps {
  className?: string;
  currentPoints: number;
  chargePoints: number;
  hideTotalPoints?: boolean;
}

export function ChargePointDetails({
  className,
  currentPoints,
  chargePoints,
  hideTotalPoints = false,
}: ChargePointDetailsProps): React.ReactNode {
  const totalPoints = currentPoints + chargePoints;

  return (
    <Column
      align="center"
      gap={10}
      className={clsx(
        "w-full rounded-[10px] border-[#c8c8c8] border-solid border-[1px] box-border",
        "py-[18px] px-[19px]",
        "leading-[normal] tracking-[normal] text-left",
        className
      )}
    >
      <PointDetailRow label="現在の保有ポイント" value={currentPoints.toLocaleString()} />
      <PointDetailRow
        label="チャージポイント"
        value={`+${chargePoints.toLocaleString()}`}
        isChargedPoint
      />
      {!hideTotalPoints && (
        <PointDetailRow
          label="チャージ後のポイント残高"
          value={totalPoints.toLocaleString()}
          hasBorder
        />
      )}
    </Column>
  );
}
